exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/_object-gops.js
// module id = 34
// module chunks = 0 1